// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Button } from '@carbon/react';
import { CloseOutline } from '@carbon/icons-react';

/** Why the Revoke control is inert. Stated in the open, not in a tooltip. */
export const REVOKE_UNAVAILABLE =
  'Revoke is not yet supported by the approval service. Its decision endpoint records ' +
  'a review verdict, not an abort, so pressing this could only write a misleading entry ' +
  'into the audit trail.';

/** Ties the button to its reason across the two places they render. */
export const REVOKE_REASON_ID = 'live-revoke-reason';

/**
 * `Revoke — revert to baseline`, in the page header beside the Live title.
 *
 * Renders **disabled**: there is no revoke contract upstream. Keeping it
 * visible-but-inert preserves the design intent without implying an abort path
 * exists (see {@link REVOKE_UNAVAILABLE}).
 */
export function LiveRevokeButton() {
  return (
    <Button
      kind="danger--tertiary"
      size="md"
      renderIcon={CloseOutline}
      disabled
      aria-describedby={REVOKE_REASON_ID}
    >
      Revoke — revert to baseline
    </Button>
  );
}

/**
 * The reason, rendered in the panel body rather than in the header.
 *
 * It has to be readable text rather than a tooltip on the button: a disabled
 * control takes neither hover nor focus in most browsers, so a tooltip on it is
 * a reason nobody can read. It sits here instead of in the header's action slot
 * so a three-line paragraph doesn't stretch the title row.
 */
export function LiveRevokeNote() {
  return (
    <p className="live-revoke-note" id={REVOKE_REASON_ID}>
      {REVOKE_UNAVAILABLE}
    </p>
  );
}
